import Vue from 'vue'

Vue.directive('min-height', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    el.style.minHeight = document.documentElement.clientHeight + 'px'
  }
})



// WEBPACK FOOTER //
// ./src/directives/index.js